export default __webpack_public_path__ + "static/media/ic_events.6433cfb0.svg";